import { render } from "./SelecionarKitProdutos.vue?vue&type=template&id=de654310&scoped=true&ts=true"
import script from "./SelecionarKitProdutos.vue?vue&type=script&lang=ts"
export * from "./SelecionarKitProdutos.vue?vue&type=script&lang=ts"

import "./SelecionarKitProdutos.vue?vue&type=style&index=0&id=de654310&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de654310"]])

export default __exports__